import { useParams } from 'react-router-dom';
import CuDeCustomer from './cudeCustomer';
import CuDeAppointment from './cudeAppointment';
import CuDeInvoice from './cudeInvoice';
import CuDeNote from './cudeNote';
import CuDeTodo from './cudeTodo';

function CustomerDetail() {
    const { id } = useParams();

    return (
        <div className="cudePageContainer">
            <CuDeCustomer id={id} />

            <CuDeAppointment id={id} />

            <CuDeTodo id={id} />

            <CuDeNote id={id} />

            <CuDeInvoice id={id} />
        </div>
    );
}

export default CustomerDetail;